import moment from "moment";
import { RdoStatus, RdoStatusEnum } from "./rdoOperacoes.types";

export function formatHa(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "—";
  }
  return Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 0 });
}

export function formatRdoDate(value: string | null | undefined): string {
  if (!value) return "—";
  const m = moment(value);
  if (!m.isValid()) return "—";
  return m.format("DD/MM/YYYY");
}

export function formatPct(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "—";
  }
  return `${Math.round(Number(value))}%`;
}

/** RN09: só linha consolidada da classe; EmAtencao|Atrasada e área > 0. */
export function shouldWarnARealizar(
  isParent: boolean,
  status: RdoStatus,
  areaARealizar: number | null | undefined
): boolean {
  if (!isParent) return false;
  const area = areaARealizar == null ? 0 : Number(areaARealizar);
  return (
    area > 0 &&
    (status === RdoStatusEnum.EmAtencao || status === RdoStatusEnum.Atrasada)
  );
}

/** RN09: só linha pai; ritmo < meta ajustada (campos API; sem recalcular). */
export function shouldWarnMetaAjustada(
  isParent: boolean,
  ritmoDiario: number | null | undefined,
  metaDiariaAjustada: number | null | undefined
): boolean {
  if (!isParent) return false;
  if (ritmoDiario == null || metaDiariaAjustada == null) return false;
  return Number(ritmoDiario) < Number(metaDiariaAjustada);
}
